import { ReportedFinding, PortfolioServiceTag, ServiceCode } from '@acp/shared';
import { SimpleGrid } from '@chakra-ui/react';
import { PropertyService } from '../../../portfolio';

export function ServiceIcons({ service }: { service: ReportedFinding['service'] }) {
    const isStandaloneCordedBlinds = service.suffix === ServiceCode.CORDED_BLINDS;

    return (
        <SimpleGrid
            columns={3}
            rowGap={2}
            columnGap={2}
            alignItems="start"
            templateColumns="repeat(3, min-content)"
        >
            <PropertyService
                service={{ shortName: service.suffix, tags: service.tags }}
                key={service.suffix}
            />
            {!isStandaloneCordedBlinds
                && service.tags?.includes(PortfolioServiceTag.CordedBlinds) && (
                <PropertyService service={{ shortName: ServiceCode.CORDED_BLINDS, tags: [] }} />
            )}
            {service.tags?.includes(PortfolioServiceTag.WaterEfficiency) && (
                <PropertyService service={{ shortName: 'water', tags: [] }} />
            )}
            {service.tags?.includes(PortfolioServiceTag.RCD) && (
                <PropertyService service={{ shortName: 'rcd', tags: [] }} />
            )}
        </SimpleGrid>
    );
}
